export default __webpack_public_path__ + "static/media/longCloud21.19b76381.webp";